import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/styles';
import {graphql, useStaticQuery} from "gatsby";

import Breadcrumb from '../Breadcrumb';
import { CgbImageLinkBlock } from '../blocks/CgbImageLinkBlock';
import { CoreHeadingBlock } from '../blocks/CoreHeadingBlock';
import styles from './StockistListPage.styles';
import linkContact from '../../images/link-contact.png';
import linkStockists from '../../images/link-stockists.png';
import linkBack from '../../images/link-back.png';

import Link from '../Link';

const useStyles = makeStyles(theme => styles(theme));

export default function StockistListPage({ stockists, renderReturnButton }) {
  const classes = useStyles();

  const data = useStaticQuery(graphql`
    query FeaturedStockists {
      allWpStockist(filter: {stockists: {featured: {eq: true}, online: {eq: true}}}) {
        edges {
          node {
            id
            title
            stockists {
              logo {
                id
                sourceUrl
              }
              online
              url
            }
          }
        }
      }
    }
  `);

  // console.log(data);

  return <>
    <Breadcrumb
      type="category"
      current={{
        title: 'Online Stockist',
        slug: 'online stockist',
        uri: '/online stockist'
      }}
    />
    <section className={classes.pageTitle}>
      <h1>Online Stockists</h1>
    </section>
    <Grid container spacing={3} className={classes.results}>
      <Grid item sm={12}>
        <CoreHeadingBlock
          attributes={{
            align: "",
            anchor: "",
            className: "",
            content: "Online Retailers",
            level: 4,
            textColor: "",
            backgroundColor: "",
            __typename: "WpCoreHeadingBlockAttributes",
        }}
        innerBlocks={[]} 
      />
      </Grid>
      {data.allWpStockist.edges !== null && data.allWpStockist.edges.map(stockist => {
        return <Grid item sm={6} md={3}>
          <Link to={stockist.node.stockists.url} className={classes.stockist}>
            <img src={stockist.node.stockists.logo.sourceUrl} alt={stockist.node.title} />
            <span>{stockist.node.title}</span>
          </Link>
        </Grid>
      })}
      { stockists.edges.map(stockist => {
        return <Grid item sm={6} md={3}>
          <Link to={stockist.node.stockists.url} className={classes.stockist}>
            <img src={stockist.node.stockists.logo.sourceUrl} alt={stockist.node.title} />
            <span>{stockist.node.title}</span>
          </Link>
        </Grid>
      }) }
    </Grid>
    <section>
      <Grid container spacing={3} direction="row" justify="left" alignItems="center" className={`image-link-row ${classes.imageLinkRow} ${classes.imageLinkRowTheme}`}>
          <Grid item xs={12} md={4}>
            <CgbImageLinkBlock attributes={{ text: 'Search local stockist', linkURL: '/stockist-search', mediaUrl: linkStockists }} />
          </Grid>
          {renderReturnButton && <Grid item xs={12} md={4}>
            <CgbImageLinkBlock attributes={{ text: 'Back to product', linkURL: renderReturnButton, mediaUrl: linkBack }} />
          </Grid>}
          <Grid item xs={12} md={4}>
            <CgbImageLinkBlock attributes={{ text: 'Contact Us', linkURL: '/about-us/contact-us', mediaUrl: linkContact }} />
          </Grid>
      </Grid>
    </section>
  </>;
}